import React, { Component } from 'react';
import { Modal, Select, DatePicker, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

class UpdateBusinessTrip extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (parentRecord) => {
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            visible: true,
        }, () => {
            //打开时查询已填写的驻外信息 回显
            this.loadAbroadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadAbroadData = () => {
        const { params: { userId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserAbroadData,
            data: {
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { params } = this.state;
                params.yesNo = res.yesNo;
                params.beginDate = res.beginDate || '';
                params.endDate = res.endDate || '';
                this.setState({ params });
            },
        };
        $.sendRequest(options);
    }

    submit = () => {
        const {
            params: {
                userId,
                yesNo,
                beginDate,
                endDate,
            },
        } = this.state;
        if (yesNo === undefined || yesNo === null || yesNo === '') {
            message.warning('请选择是否驻外');
            return;
        }
        if (yesNo == 1) {
            if (!beginDate) {
                message.warning('请选择驻外开始时间');
                return;
            }
            if (!endDate) {
                message.warning('请选择驻外结束时间');
                return;
            }
        }
        if (beginDate && endDate && moment(endDate).isBefore(moment(beginDate), 'day')) {
            message.warning('驻外结束时间不能小于驻外开始时间');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.saveAbroadData,
            data: {
                userId,
                yesNo,
                beginDate: beginDate ? beginDate.slice(0, 10) : '',
                endDate: endDate ? endDate.slice(0, 10) : '',
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        //不驻外时 无需驻外时间 清空已选的驻外开始/结束时间
        if (key === 'yesNo' && value === 0) {
            params.beginDate = '';
            params.endDate = '';
        }
        this.setState({ params });
    }

    getContent = () => {
        const { params } = this.state;
        const { yesNo, beginDate, endDate, userCompellation, employeeCode } = params;
        const newBeginDate = beginDate ? moment(beginDate) : null;
        const newEndDate = endDate ? moment(endDate) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">人员:</div>
                    <div className="item-right">
                            {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}是否驻外:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={yesNo === undefined || yesNo === null ? undefined : yesNo}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'yesNo')}
                        >
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}驻外开始时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            disabled={yesNo === 0}
                            value={newBeginDate}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "beginDate")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}驻外结束时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            disabled={yesNo === 0}
                            value={newEndDate}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "endDate")}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="设置驻外信息"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateBusinessTrip;



// WEBPACK FOOTER //
// ./src/components/user/userInfo/UpdateBusinessTrip.js